import {DatePicker} from "@mui/x-date-pickers";
import {TextField} from "helpers/forms/fields/TextField";

/**
 * The DateField component is a form field that allows users to select a date.
 * It renders a DateSelect component and handles the date-related functionality
 * such as error handling, helper text, and default value behavior.
 *
 * @param {object} input - The input object containing the date field's value, onChange, and onFocus functions
 * @param {object} meta - The meta object containing information about the field's touch, validation, and error state
 * @param {boolean} required - The input value is required
 * @param {object} slotProps - Slotprops for the DatePicker
 * @param {...any} custom - Additional custom props to be passed to the DateSelect component
 * @returns {ReactElement} - The rendered DateField component
 */
export const DateField = ({input, meta, required, slotProps = {}, ...custom}) => (
  <DatePicker
    // @ts-expect-error TextField typing is not done yet
    slotProps={{...slotProps, textField: {...slotProps.textField, meta, required, onBlur: input.onBlur}}}
    slots={{textField: TextField}}
    enableAccessibleFieldDOMStructure={false}
    {...input}
    value={input.value || null}
    InputLabelProps={{shrink: !!input.value}}
    {...custom}
  />
);
